interface Payload {
    companyUuid: string;
    accountantUuid: string;
}

export type MainAction =
    | { type: "SET_MAIN"; payload: Payload }
    | { type: "CLEAR_MAIN" };

interface MainState {
    companyUuid: string;
    accountantUuid: string;
}

const initialState: MainState = {
    companyUuid: "",
    accountantUuid: "",
};

const main = (state = initialState, action: MainAction) => {
    switch (action.type) {
        case "SET_MAIN":
            return action.payload;
        case "CLEAR_MAIN":
            return initialState;
        default:
            return state;
    }
};
export default main;
